import service from '../../config/axios.config';

export const getAttachment = ({
  objectiveId,
  attachmentId
}) =>
  service.get(
    `/objectives/${objectiveId}/attachments/${attachmentId}`,
    {
      responseType: 'blob'
    }
  );

export const getAttachmentsByObjective = ({
  objectiveId
}) =>
  service.get(
    `/objectives/${objectiveId}/attachments`
  );

export const createAttachment = ({
  file,
  objectiveId
}) => {
  var formData = new FormData();
  formData.append('file', file);
  return service.post(
    `/objectives/${objectiveId}/attachments`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
};

export const deleteAttachment = ({
  objectiveAttachmentId,
  objectiveId
}) => {
  return service.delete(
    `/objectives/${objectiveId}/attachments/${objectiveAttachmentId}`
  );
};
